module.exports = __webpack_public_path__ + "media/images/iconPaginatePrev__inFrontOfAccent--dark-d1a059497a036afd6ae02cadfcbf158f.png";